import { add, format, startOfHour } from 'date-fns';
import { AsNumber } from 'src/types/utils';

export type DateAsNumber = AsNumber<Date>;
export type ISODateString = string;
export type ISODateStringWithoutTZ = string;

export const ONE_SECOND_IN_MS = 1 * 1000;

export const ONE_MINUTE_IN_MS = ONE_SECOND_IN_MS * 60;
export const ONE_MINUTE_IN_SECONDS = 60;
export const ONE_HOUR_IN_MS = ONE_MINUTE_IN_MS * 60;
export const ONE_HOUR_IN_SECONDS = 60 * 60;
export const ONE_DAY_IN_MS = ONE_HOUR_IN_MS * 24;

export const HALF_HOUR_IN_MINS = 30;
export const HOUR_IN_MINS = 60;

export const SP_IN_MS = HALF_HOUR_IN_MINS * ONE_MINUTE_IN_MS;

export const MINUTES_IN_SP = 30;

export const UK_TIMEZONE = 'Europe/London';
export const UTC_TIMEZONE = 'UTC';

export const getISOStringDatePart = (date: Date) => format(date, 'yyyy-MM-dd');

export function roundDownToNearestSP(time: number): Date {
  const date = new Date(time);

  // Start from the beginning of the hour
  let roundedDate = startOfHour(date);

  if (date.getMinutes() >= 30) {
    roundedDate = add(roundedDate, { minutes: HALF_HOUR_IN_MINS });
  }

  return roundedDate;
}
